/**
 * Normalise a Medicare card number for submission to the canonical API.
 *
 * The frontend validation helper (validateMedicareNumber) deliberately accepts
 * display whitespace for user entry — surrounding whitespace plus spaces and
 * tabs used for visual grouping, e.g. "2123 45670 1". The authoritative backend
 * persistence guard (authentication: MedicareCardNumberValidator, Appendix D)
 * and the bigInteger storage boundary expect the continuous-digit form, e.g.
 * "2123456701".
 *
 * This helper removes only that supported display whitespace so the submitted
 * value matches what the validator accepts. It does NOT re-implement the
 * Appendix D check-digit algorithm and performs no validation: callers validate
 * with validateMedicareNumber, and the backend remains the authoritative guard.
 *
 * A blank or whitespace-only value normalises to an empty string, preserving
 * Medicare as an optional field.
 */
export const normaliseMedicareNumberForApi = (medicareNumber: string): string => {
	return medicareNumber.trim().replace(/[ \t]+/g, '');
};
